import React, { forwardRef } from 'react';
import { Link, Button, CheckboxFilter, View, colors } from '@fairygodboss/ui';
import { LocationFilter } from './LocationFilter';
import { CompaniesFilter } from './CompaniesFilters';

export const DesktopRender = forwardRef(
    (
        {
            bodyRef,
            remoteSelected,
            onRemoteSelect,
            locationsOpen,
            isLocationsOpen,
            locations,
            onLocationSelect,
            hasRemote,
            activeLocations,
            onClearFilters,
            setActiveCompanies,
            activeCompanies,
            isSM,
            setActiveLocations,
            isAuthenticatedUser,
            companiesOpen,
            companies,
            isCompaniesOpen,
            onCompanySelect,
        },
        ref
    ) => {
        return (
            <View
                display="flex"
                p="16px"
                justifyContent="space-between"
                ref={bodyRef}
            >
                <View display="flex">
                    {hasRemote ? (
                        <View mr="24px">
                            <CheckboxFilter
                                checked={remoteSelected}
                                onClick={onRemoteSelect}
                                label="Remote/Flexible"
                            />
                        </View>
                    ) : null}
                    <CompaniesFilter
                        isSM={isSM}
                        companiesOpen={companiesOpen}
                        hasRemote={hasRemote}
                        companies={companies}
                        isCompaniesOpen={isCompaniesOpen}
                        onCompanySelect={onCompanySelect}
                        bodyRef={bodyRef}
                        activeCompanies={activeCompanies}
                        ref={ref?.companiesFilterRef}
                    />
                    <div style={{ display: 'none' }}>
                        <LocationFilter
                            ref={ref?.locationFiltersRef}
                            locationsOpen={locationsOpen}
                            isLocationsOpen={isLocationsOpen}
                            locations={locations}
                            onLocationSelect={onLocationSelect}
                            bodyRef={bodyRef}
                            activeLocations={activeLocations}
                            isSM={isSM}
                        />
                    </div>

                    <Button
                        data-qa="Jobs-Search-Filter-clear"
                        size="large"
                        variant="secondaryText"
                        onPress={() => {
                            onClearFilters();
                            if (activeCompanies?.length) {
                                setActiveCompanies([]);
                            }
                            if (activeLocations?.length) {
                                setActiveLocations([]);
                            }
                        }}
                    >
                        Clear filters
                    </Button>
                </View>
                {isAuthenticatedUser ? (
                    <View
                        pt="12px"
                        css={{
                            'a:visited': {
                                color: `${colors.primary[60]} !important`,
                                'div > svg': {
                                    path: {
                                        fill: colors.primary[60],
                                    },
                                },
                                'a:hover': {
                                    color: `${colors.primary[80]} !important`,
                                    'div > svg': {
                                        path: {
                                            fill: colors.primary[80],
                                        },
                                    },
                                },
                            },
                        }}
                    >
                        <Link href="/jobs/saved" icon variant="standalone">
                            Saved Jobs
                        </Link>
                    </View>
                ) : null}
            </View>
        );
    }
);
